import TextTitleCondensed from 'components/TextTitleCondensed.js'
import PropTypes from 'prop-types'
import React from 'react'

function OrderActionsTitle ({ value }) {
  return (
    <TextTitleCondensed className='orderActions-title'>
      {value}
    </TextTitleCondensed>
  )
}

OrderActionsTitle.propTypes = {

  value: PropTypes.string.isRequired
}

export default OrderActionsTitle
